import { useState, useEffect } from 'react'
import { useTheme } from '../contexts/ThemeContext'

export default function GoToTop() {
  const [isVisible, setIsVisible] = useState(false)
  const { theme } = useTheme()

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true)
      } else {
        setIsVisible(false)
      }
    }

    window.addEventListener('scroll', toggleVisibility)

    return () => {
      window.removeEventListener('scroll', toggleVisibility)
    }
  }, [])

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  if (!isVisible) {
    return null
  }

  return (
    <button
      onClick={scrollToTop}
      className={`fixed bottom-8 right-8 z-50 w-12 h-12 rounded-full flex items-center justify-center transition-all duration-300 shadow-lg hover:scale-110 active:scale-95 ${
        theme === 'dark'
          ? 'bg-gold-500 text-black hover:bg-gold-400'
          : 'bg-gold-500 text-black hover:bg-gold-400'
      }`}
      aria-label="Go to top"
    >
      <i className="pi pi-arrow-up text-xl"></i>
    </button>
  )
}

